/* eslint-disable linebreak-style */
import { Component, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { PurchaseOrderService } from '../purchase-order.service';
import { BranchStoreSelected } from 'src/app/pages/gestion/branch-stores/components/details/branch-store-details.component';
import { ProviderSelected } from 'src/app/pages/gestion/providers/components/details/provider-details.component';

import { CartPurchaseOrderService } from '../utils-components/cart/cart-purchase-order.service';
import { ProductsPurchaseOrderBody } from '../purchase-order.interface';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'pg-purchase-order-create',
  templateUrl: './purchase-order-create.component.html',
  providers: [MessageService]
})
export class PurchasesOrderCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  @Input() prueba: Text;
  PAYMENT_TERMS_NAMES_FOR_DROPDOWN = [
    { label: 'A', value: '1' },
    { label: 'B', value: '2' }
  ];
  TAX_NAMES_FOR_DROPDOWN = [
    { label: 'A', value: '1' },
    { label: 'B', value: '2' }
  ];
  providerSelected = new ProviderSelected('Proveedor');
  branchStoreOriginSelected = new BranchStoreSelected('Sucursal Origen');
  enable = true;
  payload = {};
  // createDate: any;
  // receptionDate: any;
  constructor(
    private fb: FormBuilder,
    private serviceBaseJoin: PurchaseOrderService,
    private cartPurchaseOrderService: CartPurchaseOrderService,
    private messageService: MessageService
  ) {
    super('', serviceBaseJoin);
  }

  ngOnInit(): void {
    this.fg = this.fb.group({
      delivery_at: [null, [Validators.required]],
      numberDocument: [null, [Validators.required]],
      paymentTerms: [null, [Validators.required]],
      tax: [null, [Validators.required]]
    });
    this.enable = true;
  }
  async onSubmit() {
    const productsPayload: ProductsPurchaseOrderBody[] =
      this.buildProductsBody();

    for (const value of Object.values(this.fg.value)) {
      if (value == null || value == '' || value == undefined) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Campos sin completar',
          detail: 'Recuerda completar los campos de Detalles'
        });
        return;
      }
    }
    if (this.providerSelected.getId() == null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Proveedor no seleccionado',
        detail: 'Recuerda seleccionar al Proveedor'
      });
      return;
    }
    if (productsPayload.length == 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Carrito vacio',
        detail: 'Recuerda incluir los Productos del Proveedor'
      });
      return;
    }

    this.payload = {
      document: {
        delivery_at: this.fg.value['delivery_at'] + 'T05:00:00.000Z',
        providerId: this.providerSelected.getId(),
        paymentTermsId: this.fg.value['paymentTerms'],
        taxId: this.fg.value['tax'],
        orderStatusId: 1,
        receptionStatusId: 1,
        invoiceStatusId: 1,
        numberDocument: this.fg.value['numberDocument']
      }
    };
    this.payload['products'] = productsPayload;
    this.createItem$(this.payload);
  }

  buildProductsBody(): ProductsPurchaseOrderBody[] {
    const cartData = this.cartPurchaseOrderService.getData();
    const productsOrderedBody = cartData.map((stockProductOrdered) => {
      return {
        productOfProviderId: stockProductOrdered.id,
        name: stockProductOrdered.description,
        unitMeasure: stockProductOrdered.unitMeasureDescription,
        quantity: Number(stockProductOrdered.quantity),
        quantity_rejected: 0,
        quantity_received: 0,
        quantity_invoiced: 0,
        unitPrice: Number(stockProductOrdered.unitPrice),
        discount: Number(stockProductOrdered.discount),
        netTotal: Number(stockProductOrdered.netTotal),
        tax: Number(stockProductOrdered.tax),
        totalTax: Number(stockProductOrdered.totalTax),
        grossTotal: Number(stockProductOrdered.grossTotal)
      };
    });
    return productsOrderedBody;
  }
  isCartEmpty() {
    return this.cartPurchaseOrderService.isCartEmpty();
  }
  ngOnDestroy() {
    this.cartPurchaseOrderService.emptyData();
  }
}
